/*
MitUnitsService - deals with setting units across the app
*/
class MitUnitsService {
  constructor() {
      this.VOLUME_UNITS = {
          MB:{
              name:'mebibyte',
              display:'mebibyte (MiB)',  //mebi
              unit:'MiB',
              convert:1048576           //1048576
          },
          GB:{
              name:'gibibyte',
              display:'gibibyte (GiB)',
              unit:'GiB',
              convert:1073741824
          },
          TB:{
              name:'tebibyte',
              display:'tebibyte (TiB)',
              unit:'TiB',
              convert:1099511627776
          },
          PB:{
              name:'pebibyte',
              display:'pebibyte (PiB)',
              unit:'PiB',
              convert:1125899906842624
          }
      }
      if(this.getCookie('vunit')){
          this.volumeUnit = this.VOLUME_UNITS[this.getCookie('vunit')];
      }
      else{
          this.volumeUnit = this.VOLUME_UNITS.TB;
      }

  }
  getVolumeUnitsList(){
      let units = [];
      for (var key in this.VOLUME_UNITS) {
          if (this.VOLUME_UNITS.hasOwnProperty(key)) {
            units.push(this.VOLUME_UNITS[key])
          }
      }
      return units;
  }
  setUserVolumeUnit(unit) {
      this.volumeUnit = unit;
      this.setCookie('vunit',unit.unit, 3650);
  }

  getUserVolumeUnit(){
      return this.volumeUnit;
  }

  setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }

}

export default new MitUnitsService();
